<template>
    <!-- <div> -->
        <div class="wbs-row schedule-bar-wrapper">
            <div v-if="devMethodology.occupancy >= 0" class="schedule-bar" :class="devMethodologyScheduleBarStyleByStatus[devMethodology.status]">
                <div class="schedule-label" :class="{'overdue': devMethodology.isOverdue}" :style="{marginLeft: offset, width: occupancy}" style="opacity: 1 !important;">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + devMethodology.step + ']'}}</span>
                    <span @mouseover="mouseOverHandler" 
                        @mouseleave="mouseLeaveHandler"
                        @mousemove="mouseMoveHandler"
                        style="width:100%; display: inline-block; height:100%; padding-top:0.5rem;">{{ devMethodology.startDate}} ~ {{ devMethodology.endDate }} 
                    </span>

                </div>
                <div class="occupancy" :style="getOccupancy()" :class="{'isHovered' : isHovered}" ref="occupancy"
                        @mouseover="mouseOverHandler" 
                        @mouseleave="mouseLeaveHandler"
                        @mousemove="mouseMoveHandler">
                    </div>
                  
                
                    <!-- <span class="dot start"></span>
                    <span class="dot end"></span> -->

                
            </div>
            <div v-else style="width:100%;" class="tbd-wrapper">
                <div class="schedule-tbd" @mouseover="mouseOverHandler"
                    @mouseleave="mouseLeaveHandler"
                    @mousemove="mouseMoveHandler">
                    <span v-if="isWbsChartExpanded" style="margin-right: 0.5rem;">{{ '[' + devMethodology.step + ']'}}</span>
                    <span class="tbd-label">TBD</span>
                </div>
            </div>
            <div v-if="isHovered" :style="{ top: mouseY + 'px', left: mouseX + 'px' }" class="schedule-tooltip" ref="scheduleTooltip">
                <div class="tooltip-header">
                    <div style="display:flex; align-items: center;">
                        Project Level
                        <span class="status-area">
                            <status-badge :status="devMethodology.status">{{formatStatusLabel(devMethodology.status) }}</status-badge>
                            <status-badge v-if="devMethodology.isOverdue" status="'OVERDUE'">Overdue</status-badge>
                        </span>
                    </div>
                   
                    <div>
                        <template v-for="num in 3">
                            <span v-if="devMethodology['l' + num]" :key="num" class="project-level"> {{ devMethodology['l' + num] }} <span class="separator"> > </span></span>
                        </template>
                    </div>
                </div>
                
                <div class="tooltip-content">
                    <div style="height: 1rem; margin-bottom:6px">
                        <progress-bar
                        :toDo="devMethodology.toDoChatterCount"
                        :inProgress="devMethodology.inProgressChatterCount"
                        :done="devMethodology.doneChatterCount"
                        :cancelled="devMethodology.cancelledChatterCount"
                        :closed="devMethodology.closedChatterCount"/>

                    </div>
                </div>
                <div class="tooltip-content">
                    <div>
                        <span class="tooltip-content_label">Start Date:</span>
                        <span class="tooltip-content_data">{{ this.devMethodology.startDate || '-' }}</span>
                    </div>
                    <div>
                        <span class="tooltip-content_label">End Date:</span>
                        <span class="tooltip-content_data">{{ this.devMethodology.endDate || '-' }}</span>
                    </div>
                </div>
            </div> 
            <!-- 하위 Chatter 호출 -->
            <template v-if="isExpanded">
                <template v-for="chatter in devMethodology.chatterList">
                    <chatter-schedule-bar :chatter="chatter" :depth="depth + 1" :key="chatter.chatId" />
                </template>
            </template>
            <!-- 자신을 재귀적으로 호출 --> 
            <template v-if="isExpanded">
                <template v-for="nextStep in devMethodology.children">
                    <dev-methodology-schedule-bar :devMethodology="nextStep" :depth="depth + 1" :key="nextStep.id"/>
                </template>
            </template>
            

        </div>


        
    <!-- </div> -->

</template>
<script>
    
    // import DevMethodologyScheduleBar from './DevMethodologyScheduleBar.vue';
    import ChatterScheduleBar from './ChatterScheduleBar.vue';
    import StatusBadge from './StatusBadge.vue';
    import ProgressBar from './ProgressBar.vue';
    export default {

        name: "DevMethodologyScheduleBar",
        props: {
            devMethodology : {type: Object},
            depth: {type: Number, default: 0}
        },
        components: {
            // DevMethodologyScheduleBar,
            StatusBadge,
            ChatterScheduleBar,
            ProgressBar,
        },
        created() {
            this.offset = this.devMethodology.offset + '%';
            this.occupancy = this.devMethodology.occupancy + '%';
            this.height = (40 - (this.depth * 10)) + '%';
        },
        data() {
            return {
                devMethodologyScheduleBarStyleByStatus : {
                    OPEN : 'schedule-level-open',
                    CLOSED : 'schedule-level-closed'
                },
                offset: '0%',
                occupancy: '0%',
                height: '0%',
                isHovered: false,
                mouseX: 0,
                mouseY: 0,
                tooltipWidth: 0
            }
        },
        computed : {
            // getDevMethodologyScheduleBar() {
            //     const offset = this.devMethodology.offset + '%';
            //     const occupancy = this.devMethodology.occupancy + '%';
            //     return {marginLeft: offset, width: occupancy};
            // },
            // getHeightByDepth() {
            //     return {height: (30 - (0 * 5)) + '%'};
            // },
            isExpanded() {
                return this.$store.getters["wbs/getExpanded"](this.devMethodology.id);
            },
            isWbsChartExpanded() {
                return this.$store.getters['wbs/getWbsScheduleChartExpandState'];
            },
            getPosition() {
                // return this.depth === 0 ? {position : 'relative'} : {position : 'absolute'};
                return {};
            },
            colorInfoByStatusAndDepth() {
                return this.$store.getters['wbs/getColorInfoByStatusAndDepth'];
            },
            viewportWidth() {
                return window.innerWidth;
            }
        },
        methods: {
// {marginLeft: offset, width: occupancy, backgroundColor: getBackgroundColor()}
            getOccupancy() {
                let depth = 0;
                if(this.depth >= 4) {
                    depth = 4;
                } else {
                    depth = this.depth;
                }
                return {
                    marginLeft: this.offset,
                    width: this.occupancy,
                    backgroundColor: this.colorInfoByStatusAndDepth[this.devMethodology.status][depth],
                    // border: '2px dashed ' + this.colorInfoByStatusAndDepth[this.devMethodology.status][this.colorInfoByStatusAndDepth[this.devMethodology.status].length - 1]
                }
            },
            mouseOverHandler() {
                this.isHovered = true;

                this.$nextTick(() => {
                    this.tooltipWidth = this.$refs.scheduleTooltip.offsetWidth;
                })

            },

            mouseLeaveHandler() {
                this.isHovered = false;
            },

            mouseMoveHandler(event) {
                const defaultOffset = 30;
                // 마우스 위치와 툴팁 넓이의 합이
                // 클라이언트 뷰포트 - 마우스 위치보다 크다면 
                // 툴팁을 왼쪽으로 이동

                // 마우스 위치 X
                const clientX = event.clientX;
                // 마수으 위치 Y
                const clientY = event.clientY;
                if(clientX + this.tooltipWidth + defaultOffset >= this.viewportWidth) {
                    this.mouseX = clientX - (defaultOffset + this.tooltipWidth)
                } else {
                    this.mouseX = clientX + defaultOffset;
                }
    
                // this.mouseX = event.clientX - (30 + event.clientX ); // 빼는 것을 event.clientX가 아닌 tooltipWidth로 해야함
                this.mouseY = clientY - 5;
            },

            formatStatusLabel(text) {
                if(!text) return;
                const words = text.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
                return words.join(" ");
            },
        }
        
    }
</script>

<style>
* {
    box-sizing: border-box;
}
.schedule-bar-wrapper {
    display: flex;
    flex-direction: column;
    height:unset;
    position:relative;
    /* overflow: hidden; */
    /* background-color: white; */
    /* margin: 0.3rem 0; */
    /* background-color: transparent; */
    /* align-items: center; */
}
.schedule-bar-wrapper .schedule-label.overdue {
    color: red;
}
.schedule-bar-wrapper .schedule-label.overdue + .occupancy{
    border-color: red !important;
}
.schedule-bar {
    height: 2.3rem;
    width: 100%;
    overflow:hidden;
    /* position: relative; */
}
/* 
.schedule-bar div {
    align-items: center;
    font-weight: bold;
    text-align: center;
    height: 30%;
    font-size: 0.7rem;
    flex-shrink: 0;
} */

.schedule-bar div.schedule-label {
    /* position: absolute; */
    font-weight: bold;
    position: sticky;
    left: 0;
    height: 2.2rem;
    min-width: 15rem;
    display: flex;
    align-items: center;
    z-index: 10;
    padding-left:0.5rem;
    font-size: 0.9rem;
    color: black;
    /* pointer-events: none; */
}


/* .schedule-bar .occupancy { */
.occupancy {
    z-index: 1;
    position:absolute;
    height: 100%;
    border-radius: 10px;
    top: 0;
    opacity: 0.6;
    /* border: 0.3px solid black; */
    /* padding: 0.3rem 0; */

    /* height: 30%;
    display: flex;
    justify-content: space-between;
    position: relative;
    border-radius: 15px;
    background-color: none !important; */
    /* position: absolute; */
}

.occupancy.isHovered {
    opacity: 1;
    border-width: 3px !important;
    box-shadow: 0px 0px 5px grey;
}

.schedule-bar .occupancy .dot {
    display: inline-block;
    height: 12px;
    width: 5px;
    border-radius: 2px;
    position: absolute;
    top: 50%;
    transform:translateY(-50%)
}

.tbd-wrapper {
    width: 100%;
    display: flex;
    justify-items: center;
    /* position: relative; */
    min-height:2.3rem;
    /* align-items: center; */
}

.schedule-tbd {
    /* background: repeating-linear-gradient(45deg, #444, #444 2px, transparent 0, transparent 20px); */
    position: absolute;
    border: 1px solid grey;
    /* z-index: 11; */
    /* left: 50%;
    transform: translateX(-50%); */
    text-align: center;
    height: 100%;
    width: 100%;
    background-color: transparent;
    z-index: 1;
    /* z-index: 30; */
    opacity: 0.3;
}
.schedule-tbd:hover {
    opacity: 1;
    border: 2px solid black;
    /* background-color: rgb(246, 246, 250); */
    box-shadow: 0px 0px 5px grey;
}
.schedule-tbd .tbd-label {
    position: sticky;
    z-index: 11;
    margin-top: 0.38rem;
    left: 50%;
    display: inline-block;
    transform: translateX(-50%);
}
/* 
.schedule-closed .schedule-label {
    color: #168D4C;   
}
.schedule-closed .occupancy .dot {
    background-color: #168D4C;
}
.schedule-closed .occupancy{
    background-color : #D7F5D6;
} */


.schedule-level-open .occupancy {
    border: 2px dashed black;
}

.schedule-level-closed .occupancy {
    border: 2px dashed #168D4C;
}

.schedule-tooltip {
    font-family: 'NanumGothic';
    border-bottom: 1px solid;
    padding: 0.8rem;
    position: fixed;
    /* width: 200px; */
    /* height: 200px; */
    border-radius: 10px;
    background-color: rgb(246, 246, 250);
    box-shadow: 0px 0px 5px grey;
    z-index: 30;
    /* transition: 0.2 all ease-in; */
}

.schedule-tooltip .tooltip-header {
    width: 100%;
    font-size: 1.4rem;
    font-weight: bold;
    border-bottom: 1px solid grey;
    margin-bottom: 0.7rem;
    line-height: normal;
}
.schedule-tooltip .tooltip-header .status-area {
    font-size: 1rem;
    margin-left: 0.2rem;
}

.schedule-tooltip .project-level {
    font-size: 0.9rem;
    font-weight: normal;

}
.schedule-tooltip .project-level:last-child {
    font-size: 1.1rem;
    font-weight: bold;   
}
.schedule-tooltip .project-level:last-child .separator {
    display: none;
}
.schedule-tooltip .tooltip-content_label {
    text-align: right;
    font-weight: bold;
    display: inline-block;
    width: 6rem;
    /* border-right: 1px solid grey; */
    margin-right: 0.4rem;
}
</style>